// components/dialogs/MarkAsDeceasedDialog.tsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

interface MarkAsDeceasedDialogProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const MarkAsDeceasedDialog: React.FC<MarkAsDeceasedDialogProps> = ({
  open,
  onClose,
  onContinue,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>⚠️ Mark as deceased</DialogTitle>
      <DialogContent>
        You are about to mark a customer as deceased. Setting the customer as 
        deceased will overwrite some existing values and will make the form read-only.
        <br />
        <br />
        This action can be undone by unchecking the deceased status if needed.
        <br />
        <br />
        Are you sure you want to make this change?
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button variant="text" onClick={onContinue}>
          Mark as deceased
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          color="warning"
        >
          Go Back
        </Button>
      </DialogActions>
    </Dialog>
  );
};